var _rect, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgPdfAttached = function SvgPdfAttached(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 32,
    height: 32,
    fill: "none"
  }, props), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 32,
    height: 32,
    fill: "#3B7CC9",
    rx: 4
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    fillRule: "evenodd",
    d: "M11 8.5a.833.833 0 0 0-.834.833v13.334c0 .46.374.833.834.833h10c.46 0 .833-.373.833-.833v-10a.833.833 0 0 0-.244-.59l-3.333-3.333a.833.833 0 0 0-.59-.244H11Zm.833 13.333V10.167h5.488l2.845 2.845v8.821h-8.333ZM13.5 16a.833.833 0 0 0 0 1.667h5a.833.833 0 1 0 0-1.667h-5Zm-.834-1.667c0-.46.374-.833.834-.833h3.333a.833.833 0 0 1 0 1.667H13.5a.833.833 0 0 1-.834-.834ZM13.5 18.5a.833.833 0 0 0 0 1.667h5a.833.833 0 1 0 0-1.667h-5Z",
    clipRule: "evenodd"
  })));
};
export default SvgPdfAttached;